import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import VueJwtDecode from "vue-jwt-decode";

// SUPER ADMIN PAGES
import MainLayoutAdmin from "../views/layout/super-admin/main.vue";
import DashboardAdmin from "../views/pages/super-admin/DashboardAdmin.vue";
import AddProjectStep1 from "../views/pages/super-admin/AddProjectStep1.vue";
import AddProjectStep2 from "../views/pages/super-admin/AddProjectStep2.vue";
import DetailProject from "../views/pages/super-admin/DetailProject.vue";
import Cronjob from "../views/pages/super-admin/Cronjob.vue";
import Settings from "../views/pages/super-admin/Settings.vue";

// CLIENT PAGES
import Dashboard from "../views/pages/Dashboard.vue";
import Mention from "../views/pages/Mention.vue";
import Sources from "../views/pages/Sources.vue";
import Search from "../views/pages/Search.vue";
import NewsTrend from "../views/pages/NewsTrend.vue";
import NewsTrendDetail from "../views/pages/NewsTrendDetail.vue";
import DataCleansing from "../views/pages/DataCleansing.vue";
import HistoryDataCleansing from "../views/pages/HistoryDataCleansing.vue";
import General from "../views/pages/analytics/General.vue";
import Maps from "../views/pages/analytics/Maps.vue";
import SNA from "../views/pages/analytics/SNA.vue";
import NER from "../views/pages/analytics/NER.vue";
import NEA from "../views/pages/analytics/NEA.vue";
import MediaTendency from "../views/pages/analytics/Mediatendency.vue";
import TrustMeter from "../views/pages/analytics/Trustmetter.vue";
import TrendingAnalysis from "../views/pages/analytics/Trendinganalysis.vue";
import Narasumber from "../views/pages/analytics/Narasumber.vue";
import QuoteExtraction from "../views/pages/analytics/QuoteExtraction.vue";
import BotDetection from "../views/pages/analytics/BotDetection.vue";
import Sentiment from "../views/pages/analytics/Sentiment.vue";
import TwitterTrending from "../views/pages/trending-topik/TwitterTrending.vue";
import GoogleTrending from "../views/pages/trending-topik/GoogleTrending.vue";
import HeadlineMediaCetak from "../views/pages/trending-topik/HeadlineMediaCetak.vue";
import TrashBin from "../views/pages/TrashBin.vue";
import Keyword from "../views/pages/settings/Keyword.vue";
import Users from "../views/pages/settings/User.vue";
import Channel from "../views/pages/settings/Channel.vue";
import Media from "../views/pages/settings/Media.vue";
import HubungkanAkun from "../views/pages/settings/HubungkanAkun.vue";
import Profile from "../views/pages/Profile.vue";
import DetailAkun from "../views/pages/DetailAkun.vue";
import View from "../views/pages/View.vue";

// MAIN LAYOUT
import MainLayout from "../views/layout/main.vue";
import NoAUthMainLayout from "../views/layout/noauth/main.vue";
import Login from "../views/pages/Login.vue";
import PageNotFound from "../views/pages/Error404.vue";

Vue.use(VueRouter);

const routes = [
  // SUPER ADMIN ROUTES
  {
    path: "/admin",
    name: "LayoutAdmin",
    component: MainLayoutAdmin,
    redirect: "/admin/dashboard",
    meta: {
      requiresAuth: true,
    },
    children: [
      // SUPER ADMIN DASHBOARD
      {
        path: "/admin/dashboard",
        name: "Admin Dashboard",
        component: DashboardAdmin,
        meta: {
          requiresAuth: true,
          permission: [1],
        },
      },
      // SUPER ADMIN CRONJOB
      {
        path: "/admin/cronjob",
        name: "Cronjob Dashboard",
        component: Cronjob,
        meta: {
          requiresAuth: true,
          permission: [1],
        },
      },
      // SUPER ADMIN SETTINGS
      {
        path: "/admin/setting",
        name: "Setting Dashboard",
        component: Settings,
        meta: {
          requiresAuth: true,
          permission: [1],
        },
      },
      // SUPER ADMIN ADD PROJECT
      {
        path: "/admin/project/step1",
        name: "Add Project Dashboard 1",
        component: AddProjectStep1,
        meta: {
          requiresAuth: true,
          permission: [1],
        },
      },
      {
        path: "/admin/project/step2",
        name: "Add Project Dashboard 2",
        component: AddProjectStep2,
        meta: {
          requiresAuth: true,
          permission: [1],
        },
      },
      // SUPER ADMIN PROJECT DETAIL
      {
        path: "/admin/project/detail",
        name: "Detail Project",
        component: DetailProject,
        meta: {
          requiresAuth: true,
          permission: [1],
        },
      },
    ],
  },
  // CLIENT ROUTES
  {
    path: "/",
    name: "Layout",
    component: MainLayout,
    redirect: "/dashboard",
    _children: [
      // DASHBOARD
      {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // MENTIONS
      {
        path: "/posts",
        name: "Posts",
        component: Mention,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // SOURCE
      {
        path: "/sources",
        name: "Sources",
        component: Sources,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // SEARCH
      {
        path: "/search",
        name: "Search",
        component: Search,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // NEWS TREND
      {
        path: "/newstrend",
        name: "NewsTrend",
        component: NewsTrend,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // DETAIL NEWS TREND
      {
        path: "/newstrend/detail",
        name: "NewsTrendDetail",
        component: NewsTrendDetail,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // DATA CLEANSING
      {
        path: "/cleansing",
        name: "Cleansing",
        component: DataCleansing,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // HISTORY DATA CLEANSING
      {
        path: "/history-cleansing",
        name: "HistoryDataCleansing",
        component: HistoryDataCleansing,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS GENERAL
      {
        path: "/analytics",
        name: "General",
        component: General,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS MAP
      {
        path: "/maps",
        name: "Maps",
        component: Maps,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS SNA
      {
        path: "/sna",
        name: "SNA",
        component: SNA,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS NER
      {
        path: "/ner",
        name: "NER",
        component: NER,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS NEA
      {
        path: "/nea",
        name: "NEA",
        component: NEA,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS MEDIA TENDENCY
      {
        path: "/media-tendency",
        name: "MediaTendency",
        component: MediaTendency,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS TRUST METER
      {
        path: "/trust-meter",
        name: "TrustMeter",
        component: TrustMeter,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS TRENDING ANALYSIS
      {
        path: "/trending-analysis",
        name: "TrendingAnalysis",
        component: TrendingAnalysis,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS NARASUMBER
      {
        path: "/narasumber",
        name: "Narasumber",
        component: Narasumber,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS QUOTE EXTRACTION
      {
        path: "/quote",
        name: "Quote Extraction",
        component: QuoteExtraction,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS BOT DETECTION
      {
        path: "/bot-detection",
        name: "BotDetection",
        component: BotDetection,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS SENTIMENT
      {
        path: "/sentiment",
        name: "Sentiment",
        component: Sentiment,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // TWITTER TRENDING
      {
        path: "/twitter-trending",
        name: "TwitterTrending",
        component: TwitterTrending,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // GOOGLE TRENDING
      {
        path: "/google-trends",
        name: "GoogleTrending",
        component: GoogleTrending,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // HEADLINE MEDIA CETAK
      {
        path: "/headline-media-cetak-nasional",
        name: "HeadlineMediaCetak",
        component: HeadlineMediaCetak,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // TRASHBIN
      {
        path: "/trashbin",
        name: "TrashBin",
        component: TrashBin,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // SETTINGS KEYWORD
      {
        path: "/setting-keyword",
        name: "Keyword",
        component: Keyword,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // SETTINGS USER
      {
        path: "/setting-users",
        name: "Users",
        component: Users,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // SETTINGS CHANNEL
      {
        path: "/setting-channel",
        name: "Channel",
        component: Channel,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // SETTINGS HUBUNGKAN AKUN
      {
        path: "/setting-hubungkan-akun",
        name: "HubungkanAkun",
        component: HubungkanAkun,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // SETTINGS MEDIA
      {
        path: "/setting-media",
        name: "Media",
        component: Media,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // PROFILE
      {
        path: "/profile",
        name: "Profile",
        component: Profile,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // DETAIL AKUN
      {
        path: "/detail-akun",
        name: "DetailAkun",
        component: DetailAkun,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // TESTING INLINE EDIT TABLE
      {
        path: "/coba-inline-edit",
        name: "CobaSimpleTable",
        component: () => import("../views/pages/CobaSimpleTable.vue"),
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
    ],
    get children() {
      return this._children;
    },
    set children(value) {
      this._children = value;
    },
  },
  // MAIN LAYOUT
  {
    path: "/",
    name: "LayoutNoAuth",
    component: NoAUthMainLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "/view",
        name: "View",
        component: View,
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  // LOGIN
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  // ERROR 404
  { path: "*", name: "Error404", component: PageNotFound },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (to.matched.some((record) => record.meta.permission)) {
        let user_role;
        if (store.getters.token) {
          let token_decode = VueJwtDecode.decode(store.getters.token);
          user_role = token_decode.role;
        } else {
          user_role = store.getters.user.role;
        }

        if (to.meta.permission.includes(user_role)) {
          next();
          return;
        } else {
          next("/login");
          return;
        }
      }
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router;
